import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import ApolloClient from './graphql/ApolloClient';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
import { store } from './config/configureStore';
import registerServiceWorker from './registerServiceWorker';
import { addLocaleData, IntlProvider } from 'react-intl';
import enMessages from './translations/lang/en-US.json';
import esMessages from './translations/lang/es.json';
import Intl from 'intl';
import 'intl/locale-data/jsonp/en';
import 'intl/locale-data/jsonp/es';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import 'alertifyjs/build/alertify.min.js';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import 'alertifyjs/build/css/themes/bootstrap.min.css';
import './ResponsiveStyles.css';
import './ResetStyles.css';
import { get } from 'lodash';
var locale = require('browser-locale')();
var localeLanguage;
addLocaleData([...en, ...es]);

var languagePackAPI = new Promise(function(resolve, reject) {
  var request = new XMLHttpRequest();
  var LANUGUAGE_SETTINGS_URL =
    '/api_entry_point/olo/get/lavutogoLanguagePack/lavutogoname/';
  request.open(
    'GET',
    process.env.REACT_APP_PHP_API_URL +
      LANUGUAGE_SETTINGS_URL +
      window.location.pathname.split('/')[1],
    true
  );
  request.onload = function() {
    var data = JSON.parse(this.response);
    if (request.status >= 200 && request.status < 400) {
      const languageId = get(data, 'DataResponse[0][0].id', 0);
      localStorage.setItem('language', languageId);
      resolve(data);
    } else {
      reject('error');
    }
  };
  request.send();
});

languagePackAPI.then(function(response) {
  switch (localStorage.getItem('language')) {
    case '1':
      localeLanguage = enMessages;
      break;
    case '2':
      localeLanguage = esMessages;
      break;
    default:
      localeLanguage = enMessages;
  }

  let langKeyArr = [
    'error',
    'pleaseAddItemToCart',
    'ok',
    'contactRestaurant',
    'success',
    'somethingWentWrong',
    'yes',
    'no',
  ];
  let langKeyValObj = {};
  langKeyArr.forEach(element => {
    let key = element;
    let val =
      localeLanguage[element] == 'undefined'
        ? enMessages[element]
        : localeLanguage[element];
    langKeyValObj[key] = val;
  });
  localStorage.setItem('langVars', JSON.stringify(langKeyValObj));

  function get_language(locale) {
    const dash_index = locale.indexOf('-');
    if (dash_index >= 0) {
      return locale.substring(0, dash_index);
    }
    return locale;
  }

  global.store = store;
  ReactDOM.render(
    <ApolloProvider client={ApolloClient}>
      <Provider store={store}>
        <IntlProvider locale={get_language(locale)} messages={localeLanguage}>
          <Router history={browserHistory} routes={routes} />
        </IntlProvider>
      </Provider>
    </ApolloProvider>,
    document.getElementById('root')
  );
  registerServiceWorker();
});



// WEBPACK FOOTER //
// ./src/index.js